const PLACEHOLDER =
  "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png";

/**
 * Manual KYC stores paths like `public/kycdoc/x.webp`.
 * Online KYC often stores raw base64 (or data: URLs).
 */
export function kycImageSrc(src, baseUrl = process.env.REACT_APP_API_BASE_URL) {
  if (!src) return PLACEHOLDER;
  const value = String(src).trim();
  if (!value) return PLACEHOLDER;

  if (value.startsWith("data:") || /^https?:\/\//i.test(value)) {
    return value;
  }

  // File path from offline / admin manual upload
  if (
    value.includes("public/") ||
    value.includes("kycdoc") ||
    value.startsWith("/") ||
    /\.(webp|jpe?g|png|gif|bmp)$/i.test(value)
  ) {
    const root = String(baseUrl || "").replace(/\/+$/, "");
    const path = value.replace(/^\/+/, "");
    return `${root}/${path}`;
  }

  // Raw base64 from online KYC
  return `data:image/jpeg;base64,${value}`;
}

export default kycImageSrc;
